import React, { useState, useEffect } from 'react';
import { Checkbox, FormControlLabel, FormGroup, Button, Typography, Box, Grid, CircularProgress } from '@mui/material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const TimeOfAvailabilitySelection = ({ userId }) => {
    const [availabilityOptions, setAvailabilityOptions] = useState([
        "Early Morning (12:00 AM - 9:00 AM)",
        "Morning (9:00 AM - 12:00 PM)",
        "Afternoon (12:00 PM - 3:00 PM)",
        "Evening (3:00 PM - 6:00 PM)",
        "Night (6:00 PM - 12:00 AM)",
        "Weekend (Saturday - Sunday)",
        "Weekdays (Monday - Friday)",
        "All the Time (24/7)",
        "Instantly Available (Right now)",
        "During Holidays (Public/Company holidays)",
        "Only during Day (9:00 AM - 6:00 PM)",
        "Only during Night (6:00 PM - 12:00 AM)",
        "Currently Not Available"
    ]);

    const [selectedAvailability, setSelectedAvailability] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        if (userId) {
            axios.get(`${API_URL}/api/user_availability/`, {
                params: { user_id: userId }  // Pass user_id as a query parameter
            })
                .then(response => {
                    setSelectedAvailability(response.data.availability || []);
                    if (response.data.availability.length > 0) {
                        setSubmitted(true);
                    }
                    setLoading(false);
                })
                .catch(err => {
                    setError("Error fetching user's availability.");
                    setLoading(false);
                });
        }
    }, [userId]);

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        setSelectedAvailability(prevSelected => {
            if (checked) {
                return [...prevSelected, value];
            } else {
                return prevSelected.filter(option => option !== value);
            }
        });
    };

    const handleSubmit = () => {
        axios.patch(`${API_URL}/api/user_availability/update/`, {
            user_id: userId,
            availability: selectedAvailability
        })
            .then(response => {
                setSubmitted(true);
                alert("Availability updated successfully!");
            })
            .catch(err => {
                alert("Error updating availability.");
            });
    };

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return <Typography color="error">{error}</Typography>;
    }

    return (
        <Box sx={{ backgroundColor: '#000000', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 3 }}>
            <Typography sx={{ fontSize: '2rem', marginBottom: 3, textAlign: 'center', color: '#e0e0e0', letterSpacing: 5 }}>
                {submitted ? 'Your Time of Availability' : 'Select Your Time of Availability'}
            </Typography>

            {submitted ? (
                <Box>
                    <Typography variant="h6" sx={{ color: '#e0e0e0', marginBottom: 2, letterSpacing: 4 }}>
                        Your selected availability:
                    </Typography>
                    <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
                        {selectedAvailability.map((time, index) => (
                            <Grid item xs={12} key={index}>
                                <Typography sx={{ color: '#e0e0e0', fontSize: '1.1rem', letterSpacing: 3 }}>
                                    {time}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>

                    <Typography variant="h6" sx={{ color: '#e0e0e0', marginTop: 3, marginBottom: 2, letterSpacing: 4 }}>
                        Edit your availability:
                    </Typography>
                    <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
                        <Grid item xs={12}>
                            <FormGroup>
                                {availabilityOptions.map((option, index) => (
                                    <FormControlLabel
                                        key={index}
                                        control={
                                            <Checkbox
                                                value={option}
                                                onChange={handleCheckboxChange}
                                                checked={selectedAvailability.includes(option)}
                                                sx={{
                                                    color: '#ffffff',
                                                    '&.Mui-checked': { color: '#ff8c00' },
                                                    '&:hover': { backgroundColor: 'rgba(255, 140, 0, 0.1)' },
                                                }}
                                            />
                                        }
                                        label={option}
                                        sx={{
                                            color: '#e0e0e0',
                                            fontSize: '1.1rem',
                                            '& .MuiFormControlLabel-label': {
                                                letterSpacing: 3, // Adjust spacing as needed
                                            },
                                        }}
                                    />
                                ))}
                            </FormGroup>

                        </Grid>
                    </Grid>



                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            marginTop: 3,
                        }}
                    >
                        <Button
                            sx={{
                                backgroundColor: '#ff8c00',
                                color: '#fff',
                                padding: 1.5,
                                borderRadius: '30px',
                                marginTop: 3,
                                letterSpacing: 4,
                                '&:hover': { backgroundColor: '#ff6f00' },
                            }}
                            onClick={handleSubmit}
                        >
                            Save Changes
                        </Button>
                    </Box>
                </Box>
            ) : (
                <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
                    <Grid item xs={12}>
                        <FormGroup>
                            {availabilityOptions.map((option, index) => (
                                <FormControlLabel
                                    key={index}
                                    control={
                                        <Checkbox
                                            value={option}
                                            onChange={handleCheckboxChange}
                                            checked={selectedAvailability.includes(option)}
                                            sx={{
                                                color: '#ffffff',
                                                '&.Mui-checked': { color: '#ff8c00' },
                                                '&:hover': { backgroundColor: 'rgba(255, 140, 0, 0.1)' },
                                            }}
                                        />
                                    }
                                    label={option}
                                    sx={{
                                        color: '#e0e0e0', fontSize: '1.1rem', '& .MuiFormControlLabel-label': {
                                            letterSpacing: 3, // Adjust spacing as needed
                                        },
                                    }}
                                />
                            ))}
                        </FormGroup>
                    </Grid>
                </Grid>
            )}

            {!submitted && (


                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        marginTop: 3,
                    }}
                >
                    <Button
                        sx={{
                            backgroundColor: '#ff8c00',
                            color: '#fff',
                            padding: 1.5,
                            borderRadius: '30px',
                            marginTop: 3,
                            letterSpacing: 4,
                            '&:hover': { backgroundColor: '#ff6f00' },
                        }}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default TimeOfAvailabilitySelection;
